import { Emulation } from '@awesome-cordova-plugins/star-prnt';

export const PRINTER_PORT = 'BT:TSP100';
export const PRINTER_EMU = Emulation.StarGraphic;
